import { render, staticRenderFns } from "./ModalEditEbook.vue?vue&type=template&id=3f2b224a&scoped=true&"
import script from "./ModalEditEbook.vue?vue&type=script&lang=js&"
export * from "./ModalEditEbook.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditEbook.vue?vue&type=style&index=0&id=3f2b224a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b224a",
  null
  
)

export default component.exports